import MainLayout from '../../../Components/Layout/MainLayout';
import {OrdinaryLogin} from './OrdinaryLogin';
import {SsoLogin} from './SsoLogin';
import {DynamicLogin} from './DynamicLogin';

export default function LoginSettings() {
    return (
        <MainLayout.Page
            tabs={[
                {
                    name: '动态凭证登录',
                    path: 'dynamic',
                    auth: 'hmenu_credentials_login',
                    element: <DynamicLogin />,
                },
                {
                    name: '普通登录',
                    path: 'ordinary',
                    auth: 'hmenu_normal_login',
                    element: <OrdinaryLogin />,
                },
                {
                    name: '统一身份认证接入',
                    path: 'sso',
                    auth: 'hmenu_authentication_login',
                    element: <SsoLogin />,
                },
            ]}
        />
    );
}
